import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";
function Mapper(data, status, response, error, component) {
  let output = [];
  if (data) {
    data = [data];
    data.map((itm, idx) => {
      let property = {};
      property["data"] = itm;
      property["status"] = status;
      output.push(property);
    });
  }
  return output;
}

function Properties(args) {
  return {
    data: {
      alias: "data",
      type: "hidden",
    },
    status: {
      alias: "status",
      type: "hidden",
    },
    header: {
      alias: "header",
      type: "module",
      configuration: {
        module: "header",
        view: "list",
      },
    },
  };
}

const ThankYou = {
  auth: "",
  views: {
    list: {
      apis: {
        view: {
          url: "{path}",
          replace: {
            path: function () {
              let landPageData = JSON.parse(sessionStorage.landPageData);

              if (
                landPageData.contractInfoCarrier.customerSegment === "POSTB" ||
                landPageData.contractInfoCarrier.customerSegment ===
                  "POSTB_SPLIT" ||
                landPageData.contractInfoCarrier.customerSegment === "POSTR"
              ) {
                if(landPageData.contractInfoCarrier.hasLPService){
                  return "/page/submitBillService";
                }else{
                  return "/page/submitService";
                }
              } else if(sessionStorage.getItem('pt') === 'BLNC' && landPageData.contractInfoCarrier.customerSegment === 'HYBRID_BUSINESS_COST_CONTROL'){
                return "/page/submitBillService";
              } else {
                return "/page/submitService";
              }
            },
          },
          postData: function () {
            let landPageData = JSON.parse(sessionStorage.landPageData);
            if (!landPageData.contractInfoCarrier.hasLPService) {
              sessionStorage.setItem('activation', "true")
              return {
                activation: 1,
                rli: sessionStorage.getItem("rli"),
              };
            } else if (sessionStorage.getItem("pt") === "null") {
              return {
                id: sessionStorage.getItem("id"),
                rli: sessionStorage.getItem("rli"),
              };
            } else {
              return {
                id: sessionStorage.getItem("id"),
                pt: sessionStorage.getItem("pt"),
                rli: sessionStorage.getItem("rli"),
              };
            }
          },
          method: "POST",
          mapper: Mapper,
        },
      },
      template: "thankYou",
      templateConfiguration: {
        includeProperties: [],
        excludeProperties: [],
        events: { onClick: function (e) {} },
      },
      properties: Properties({ editable: false }),
      primaryKey: "id",
    },
  },
};

export default ThankYou;
